import { useQuery } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

export interface VaultArticle {
  slug: string;
  title: string;
  kind: "reference" | "meeting" | "report" | "decision" | "insight" | "person" | "project";
  client: "evidens" | "tannico" | "agency" | "personal";
  summary: string | null;
  tags: string[];
  vault_path: string;
  created_at: string;
  updated_at: string;
  synced_at: string;
}

export interface UseVaultArticlesOpts {
  kind?: VaultArticle["kind"];
  client?: VaultArticle["client"];
  sinceDays?: number;
  query?: string;
  limit?: number;
}

export function useVaultArticles(opts: UseVaultArticlesOpts = {}) {
  return useQuery({
    queryKey: ["vault_articles", opts],
    queryFn: async () => {
      let q = supabaseAgency.from("os_vault_articles_cache").select("*");
      if (opts.kind)   q = q.eq("kind", opts.kind);
      if (opts.client) q = q.eq("client", opts.client);
      if (opts.sinceDays) {
        const since = new Date(Date.now() - opts.sinceDays * 86400_000).toISOString();
        q = q.gte("updated_at", since);
      }
      if (opts.query) {
        const term = `%${opts.query}%`;
        q = q.or(`title.ilike.${term},summary.ilike.${term},slug.ilike.${term}`);
      }
      q = q.order("updated_at", { ascending: false });
      if (opts.limit) q = q.limit(opts.limit);
      const { data, error } = await q;
      if (error) throw error;
      return (data ?? []) as VaultArticle[];
    },
  });
}
